import { motion } from "framer-motion";
import { ParallaxElement } from "./ParallaxElement";

export function BrowserMockup() {
  return (
    <div className="relative w-full max-w-lg mx-auto">
      <ParallaxElement speed={0.15} maxOffset={20}>
        <motion.div
          className="browser-mockup"
          initial={{ opacity: 0, y: 40, rotate: -2 }}
          animate={{ opacity: 1, y: 0, rotate: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        >
          <div className="browser-mockup-bar">
            <span className="browser-dot bg-red-400/70" />
            <span className="browser-dot bg-amber-400/70" />
            <span className="browser-dot bg-green-400/70" />
            <div className="browser-url">seunegocio.com.br</div>
          </div>

          <div className="p-6 space-y-5">
            <div className="flex items-center justify-between">
              <div className="h-3 w-20 skel" />
              <div className="flex gap-2">
                <div className="h-3 w-8 skel" />
                <div className="h-3 w-8 skel" />
                <div className="h-7 w-16 rounded-lg" style={{ background: "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--glow-2)))" }} />
              </div>
            </div>

            <div className="rounded-xl p-6 space-y-3" style={{ background: "linear-gradient(135deg, hsl(var(--glow-1) / 0.12), hsl(var(--glow-2) / 0.12))" }}>
              <div className="h-4 w-3/4 skel" />
              <div className="h-4 w-1/2 skel" />
              <div className="h-3 w-full skel" />
              <div className="h-3 w-5/6 skel" />
              <div className="flex gap-3 pt-2">
                <div className="h-8 w-24 rounded-lg" style={{ background: "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--glow-2)))" }} />
                <div className="h-8 w-20 rounded-lg border border-border" />
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {[0, 1, 2].map((i) => (
                <div key={i} className="rounded-lg border border-border/60 p-3 space-y-2">
                  <div className="h-6 w-6 rounded-md" style={{ background: `hsl(var(--glow-${i + 1}) / 0.25)` }} />
                  <div className="h-2 w-full skel" />
                  <div className="h-2 w-2/3 skel" />
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </ParallaxElement>
    </div>
  );
}
